export class PsnAccountLinkage {
    public gameAccountType: string;
    public gameAccountName: string;
    public hasExpired: boolean;
    public eslIdLinkAccountLocation: string;
    public eslIdManageAuthorizationsLocation: string;

    public $onInit() {
        this.eslIdLinkAccountLocation = "https://account.eslgaming.com/oauth2/v1/link/psn?return_url=" + window.location.href;
        this.eslIdManageAuthorizationsLocation = "https://account.eslgaming.com/oauth2/manage/authorizations";
    }
}
